module.exports = __webpack_public_path__ + "img/XRP.a599a23d.svg";